import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject
} from "@angular/core";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { RosterAssignmentStore } from "@app/services/store/roster/roster-assignment-store";
import { AddResourceAssignmentDialogComponent } from "./add-assignment-dialog/add-assignment-dialog.component";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { RosterAssignment } from "@app/models/rest/roster/roster-assignment";
import { ResourceModel } from "@app/models/rest/resource";
import {
  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardContent
} from "@angular/material/card";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-resource-roster-assignments",
  templateUrl: "./roster-assignments.component.html",
  styleUrls: ["./roster-assignments.component.scss"],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatButton,
    MatCardContent,
    GridComponent,
    MatPaginator
  ]
})
export class ResourceRosterAssignmentsComponent
  extends BaseDataTablePageDirective<RosterAssignment>
  implements OnInit
{
  rosterAssignmentStore: RosterAssignmentStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input() resource: ResourceModel;
  @Output() entityChange = new EventEmitter<void>();

  @Input()
  public columns: object[] = [
    {
      field: "subDivision.name",
      text: "Division",
      flex: 1,
      editor: false
    },
    {
      field: "startDate",
      text: "Start Date",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: true
    },
    {
      field: "endDate",
      text: "End Date",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: true
    },
    {
      field: "lastRunDate",
      text: "Last Run",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: false
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const rosterAssignmentStore = inject(RosterAssignmentStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      rosterAssignmentStore,
      store,
      dialog,
      "RosterAssignment",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.rosterAssignmentStore = rosterAssignmentStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.resource) {
      return;
    }

    // Configure the store to load assignments for this resource
    this.gridStore.parentField = "resource.id";
    this.gridStore.parentId = this.resource.id;
    this.gridStore.parentResource = this.resource;
    this.gridStore.parentRel = "resource";
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  openNewAssignmentDialog() {
    // Open the resource assignment dialog, passing the resource
    let dialogRef = this.dialog.open(AddResourceAssignmentDialogComponent, {
      width: "500px",
      data: {
        resource: this.resource
      }
    });

    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        // Reload data when a new assignment is added
        this.gridStore.load({});
        this.entityChange.emit();
      }
    });
  }

  commit() {
    super.commit();
    this.entityChange.emit();
  }
}
